import e from"react";import{SvgIcon as t}from"../SvgIcon.js";const r=r=>e.createElement(t,{...r},e.createElement("path",{d:"M17.001 6.81818H6.81915V17H17.001V6.81818Z"}),e.createElement("path",{d:"M13.9101 5.72727V3H3.00098v10.9091h2.72727V5.72727h8.18185Z"}));export{r as Copy};
//# sourceMappingURL=Copy.js.map
